// ABOUTME: Job overview section rendering the counter cards declared by the job presentation.
// ABOUTME: Renders nothing when the job type declares no counters, which is the default.

import { Box, Stack, Typography } from '@ds/coolshop';
import { FormattedMessage } from 'react-intl';

import { FAILURES_CARD, JobPresentation, JobPresentationContext } from '../../../../registry';
import { DetailType } from '../../../../types';
import { JobSummaryBox } from '../JobSummaryBox/JobSummaryBox';

interface IJobCountersSectionProps {
    presentation: JobPresentation;
    ctx: JobPresentationContext;
    handleToggleDetails: (title: DetailType) => void;
}

export function JobCountersSection(props: Readonly<IJobCountersSectionProps>) {
    const { presentation, ctx, handleToggleDetails } = props;

    const declared = presentation.counters?.(ctx) ?? [];
    // Errors matter for every job, including the ones that declare no counters at all.
    const withFailures = declared.some(card => card.detailType === DetailType.FAILURES)
        ? declared
        : [...declared, FAILURES_CARD];

    const cards = withFailures.map(card => ({
        ...card,
        count: ctx.counters[card.detailType] ?? 0,
    }));

    const recordCount = presentation.recordCount?.(ctx);

    return (
        <Stack gap={2}>
            {typeof recordCount === 'number' && (
                <Typography color="text.secondary">
                    <FormattedMessage
                        id="job.overview.recordCount"
                        defaultMessage="This job processed <bold>{recordCount}</bold> {recordCount, plural, one {record} other {records}}."
                        // eslint-disable-next-line react/no-unstable-nested-components
                        values={{ recordCount, bold: str => <b>{str}</b> }}
                    />
                </Typography>
            )}
            <Box>
                <JobSummaryBox
                    cards={cards}
                    groupByColor={presentation.groupCountersByColor}
                    handleToggleDetails={handleToggleDetails}
                />
            </Box>
        </Stack>
    );
}
